import { css } from 'styled-components';
import boxSizing from './box-sizing';
import normalize from './normalize';
import shared from './shared';
import reset from './reset';

export default css`
  ${boxSizing};
  ${normalize};
  ${reset};
  ${shared};
`;
